
<nbc-breadcrumb></nbc-breadcrumb>
<nbc-alert></nbc-alert>
<div>
  <template-details-filter></template-details-filter>
  <template-details-grid></template-details-grid>
</div>
